import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "menu-tab-bar__list" }
const _hoisted_2 = { class: "menu-tab-bar__icon" }

import { IMenuItem } from '@/@types/config'
import { useConfig } from '@/composables/config'

import SmIcon from '@/components/ui/SmIcon/SmIcon.vue'

import '@/components/ui/SmMenuTabBar/style.scss'

// Composables

export default /*#__PURE__*/_defineComponent({
  __name: 'SmMenuTabBar',
  setup(__props) {

const { getMainMenu } = useConfig()

// Data
const menuList = getMainMenu()

// Computed
const classList = (() => {
  return [
    { 'menu-tab-bar--scrollable': menuList.length > 4 }
  ]
})

// Methods
const getIconName = (item: IMenuItem) => {
  switch (item.route) {
    case 'Home':
      return 'calendar'
    // case 'Access':
    //   return 'lock'
    case 'Payment':
      return 'money'
    case 'Requests':
      return 'chat'
    case 'Meters':
      return 'meter'
    case 'Services':
      return 'userGroup'
    default:
      return 'circle'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["menu-tab-bar", classList])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (item, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `menu-item-${i}`,
          class: "menu-tab-bar__item"
        }, [
          _createVNode(_component_router_link, {
            to: item.route,
            class: "menu-tab-bar__link",
            "active-class": "menu-tab-bar__link--active"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(SmIcon, {
                  name: getIconName(item)
                }, null, 8, ["name"])
              ]),
              _createTextVNode(" " + _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ]))
}
}

})